module.exports = __webpack_public_path__ + "static/media/warehouse-custom.825de4ec.svg";